// LastActive.jsx
import React from "react";
import { format, formatDistanceToNow, differenceInDays } from "date-fns";

export default function LastActive({ timestamp }) {
  const date = new Date(timestamp);
  const daysDiff = differenceInDays(new Date(), date);

  let display;
  if (daysDiff < 7) {
    // Show "x minutes/hours/days ago"
    display = formatDistanceToNow(date, { addSuffix: true });
  } else {
    // Show fixed date like "Sep 2, 2025"
    display = format(date, "MMM d, yyyy");
  }

  return <span>{display}</span>;
}
